import { useQuery } from "@tanstack/react-query"
import { X } from "lucide-react"
import { DateTime } from "luxon"

import { Button } from "@/components/ui/button.tsx"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import MetricDisplay from "@/features/dashboards/components/MetricDisplay.tsx"
import { numberFmt } from "@/util/numberFmt.ts"

import { getFarm } from "../../api/getFarm.ts"

export default function OverviewPanel({
  farmId,
  clearFarm,
}: {
  farmId: number
  clearFarm: () => void
}) {
  const { data, isPending } = useQuery({
    queryKey: ["farmData", { farmId }],
    queryFn: () => getFarm(farmId),
  })

  const month = DateTime.now()
    .setZone("America/Chicago")
    .minus({ days: 1 })
    .startOf("month")
    .toFormat("MMM")

  return (
    <div className="border shadow-sm rounded-md absolute m-2 top-0 left-0 bg-white p-4 h-[165px] w-[200px]">
      {isPending && <Skeleton className="w-full h-full" />}
      {data && (
        <div className="flex flex-col gap-2">
          <div className="flex justify-between items-center">
            <h1 className="font-sans font-semibold text-[12pt]">{data.name}</h1>
            <Button variant="ghost" className="h-5 w-5" onClick={clearFarm}>
              <X />
            </Button>
          </div>
          <MetricDisplay
            label={`${month} Manure Trucked`}
            value={numberFmt(data.trips ? data.trips[0].unloadVolume || 0 : 0)}
          />
          <MetricDisplay
            label={`${month} UF Trucked`}
            value={numberFmt(data.trips ? data.trips[0].loadVolume || 0 : 0)}
          />
        </div>
      )}
    </div>
  )
}
